import Layout from '@/components/Layout';
import { PATH } from '@/constants';
import { useConfirmSyncWindowMutation, useGetOnboardingStepQuery, useUpdateOnboardingStepMutation } from '@/redux/api/api.caller';
import { handleChangeStep } from '@/redux/features/welcome.slice';
import { BlockStack, Card } from '@shopify/polaris';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import WelcomeContent from './components/WelcomeContent';
import WelcomeFooter from './components/WelcomeFooter';

const Welcome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data } = useGetOnboardingStepQuery();
  const [updateStep, { isLoading }] = useUpdateOnboardingStepMutation();
  const [confirmSyncWindow] = useConfirmSyncWindowMutation();
  const initialized = useRef(false);

  const handleSkip = async () => {
    await confirmSyncWindow({ rangeDays: 7 });
    updateStep({ onboardingStatus: true }).then(() => {
      navigate(PATH.DASHBOARD);
    });
  };

  useEffect(() => {
    if (initialized.current) return;
    if (data?.data?.onboardingStep) {
      dispatch(handleChangeStep(data.data.onboardingStep));
      initialized.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Layout title="">
      <BlockStack gap="400">
        <Card>
          <BlockStack gap="600">
            <WelcomeContent />
            <WelcomeFooter />
          </BlockStack>
        </Card>
        <WelcomeFooter skipOnly onSkip={handleSkip} isSkipLoading={isLoading} />
      </BlockStack>
    </Layout>
  );
};

export default Welcome;
